import { Icon, IconProps } from "@/base/components/icon/Icon.component";
import IconSvg from "./search.svg?react";

export const SearchIcon = (props: IconProps) => (
  <Icon component={IconSvg} {...props} />
);
